export default {"src":"https://gfiber.com/support/_next/static/media/GF-0074-CALL US.9d15cc1b.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};